import { Input as MantineInput, InputProps } from '@mantine/core';

export type IInputProps = InputProps;

/** @registry Design-layer pass-through over Mantine Input; import this instead of @mantine/core Input outside src/design. Extend here when Input needs house behavior. Compound statics (Input.Wrapper, Input.Label, ...) are preserved. */
export const Input = MantineInput;
